import { ecbrRequest } from '../../request/ecbrRequest'

export const topics = {
  getAll: async () => ecbrRequest.get('/topics'),
  getById: async (id) => ecbrRequest.get(`/topics/${id}`),
  create: async (data) => ecbrRequest.post('/topics', data),
  update: async (id, data) => ecbrRequest.patch(`/topics/${id}`, data),
  delete: async (id) => ecbrRequest.delete(`/topics/${id}`)
}
